module.exports = __webpack_public_path__ + "img/jp.c8d51fda.svg";